import { methods } from "../../utils/axios";

export default class PlansAPI {
  static getClientPlans(clientId) {
    return methods.get(`/clients/${clientId}/plans`);
  }
}
